/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toggle-switch[_ngcontent-%COMP%]{z-index:99;padding-top:.75rem;padding-right:.75rem}.buffer-area[_ngcontent-%COMP%]{padding:.75rem;margin-top:30px}"];
export { styles as styles };
